import { render, staticRenderFns } from "./SearchResultTeaser.vue?vue&type=template&id=3220c8c8&scoped=true"
import script from "./SearchResultTeaser.vue?vue&type=script&lang=js"
export * from "./SearchResultTeaser.vue?vue&type=script&lang=js"
import style0 from "./SearchResultTeaser.vue?vue&type=style&index=0&id=3220c8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220c8c8",
  null
  
)

export default component.exports